module.exports = __webpack_public_path__ + "static/media/footer2.ad0ef4b7.jpeg";